import { render } from "./OnboardingLayout.vue?vue&type=template&id=bfa52994"
import script from "./OnboardingLayout.vue?vue&type=script&lang=js"
export * from "./OnboardingLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__